enum PricingTypeEnum {
  static = 'static',
  dynamic = 'dynamic',
  miscellaneousCharge = 'miscellaneous_charge'
}

export { PricingTypeEnum }
